"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as MantineTooltip, TooltipFloating, TooltipGroup, factory, useProps, } from "@mantine/core";
import "@mantine/core/styles/Tooltip.layer.css";
const Tooltip = factory((props, ref) => {
    const modifiedProps = useProps("Tooltip", {
        withArrow: true,
        arrowSize: 8,
    }, props);
    return _jsx(MantineTooltip, { ...modifiedProps, ref: ref });
});
Tooltip.displayName = "Tooltip";
TooltipFloating.displayName = "TooltipFloating";
TooltipGroup.displayName = "TooltipGroup";
Tooltip.Floating = TooltipFloating;
Tooltip.Group = TooltipGroup;
export { Tooltip, };
//# sourceMappingURL=Tooltip.js.map